import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative py-24 sm:py-32 min-h-fit" }
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:max-w-none" }
const _hoisted_3 = { class: "mt-16 grid grid-cols-1 gap-0.5 overflow-hidden rounded-2xl text-center sm:grid-cols-2 lg:grid-cols-4" }
const _hoisted_4 = { class: "text-sm/6 font-semibold" }
const _hoisted_5 = { class: "order-first text-3xl font-semibold tracking-tight" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorldMetrics',
  setup(__props) {

const { t } = useI18n();

// Computed
const stats = computed(() => [
  { id: 1, name: t('home.worldMetrics.activeGamersWorldwide'), value: '3.32B+' },
  { id: 2, name: t('home.worldMetrics.monthlyPSNUsers'), value: '123M' },
  { id: 3, name: t('home.worldMetrics.monthlyXboxUsers'), value: '120M' },
  { id: 4, name: t('home.worldMetrics.monthlySteamUsers'), value: '132M' },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UiTitle, {
            size: "5xl",
            type: "h2",
            align: "center",
            code: _unref(t)('home.worldMetrics.tag')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.worldMetrics.title')), 1)
            ]),
            _: 1
          }, 8, ["code"]),
          _createVNode(UiParagraph, {
            class: "mt-6",
            align: "center",
            size: "lg"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('home.worldMetrics.description')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("dl", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat) => {
              return (_openBlock(), _createElementBlock("div", {
                key: stat.id,
                class: "flex flex-col bg-gray-400/5 p-8"
              }, [
                _createElementVNode("dt", _hoisted_4, _toDisplayString(stat.name), 1),
                _createElementVNode("dd", _hoisted_5, _toDisplayString(stat.value), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})